import React, { Children, Component, cloneElement } from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import classNames from 'classnames';
import debounce from 'lodash.debounce';

function isFlexSupported() {
  if (typeof window !== 'undefined' && window.document && window.document.documentElement) {
    var documentElement = window.document.documentElement;

    return 'flex' in documentElement.style || 'webkitFlex' in documentElement.style || 'Flex' in documentElement.style || 'msFlex' in documentElement.style;
  }
  return false;
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/* eslint react/no-did-mount-set-state: 0 */
var Steps = function (_Component) {
    inherits(Steps, _Component);

    function Steps(props) {
        classCallCheck(this, Steps);

        var _this = possibleConstructorReturn(this, (Steps.__proto__ || Object.getPrototypeOf(Steps)).call(this, props));

        _this.calculateUpperContentMaxHeight = function () {
            if (_this.domNode) {
                var upperContentNodes = _this.domNode.getElementsByClassName("rc-steps-item-upper-content");
                if (upperContentNodes) {
                    var upperHeights = Array.from(upperContentNodes).map(function (el) {
                        return el.clientHeight;
                    });
                    var upperContentHeight = Math.max.apply(Math, toConsumableArray(upperHeights));
                    _this.setState({ upperContentHeight: upperContentHeight });
                    console.log("Max: ", upperContentHeight);
                }
            }
        };

        _this.calcStepOffsetWidth = function () {
            if (isFlexSupported()) {
                return;
            }
            // Just for IE9
            var domNode = findDOMNode(_this);
            if (domNode.children.length > 0) {
                if (_this.calcTimeout) {
                    clearTimeout(_this.calcTimeout);
                }
                _this.calcTimeout = setTimeout(function () {
                    // +1 for fit edge bug of digit width, like 35.4px
                    var lastStepOffsetWidth = (domNode.lastChild.offsetWidth || 0) + 1;
                    // Reduce shake bug
                    if (_this.state.lastStepOffsetWidth === lastStepOffsetWidth || Math.abs(_this.state.lastStepOffsetWidth - lastStepOffsetWidth) <= 3) {
                        return;
                    }
                    _this.setState({ lastStepOffsetWidth: lastStepOffsetWidth });
                });
            }
        };

        _this.state = {
            flexSupported: true,
            lastStepOffsetWidth: 0,
            upperContentHeight: 0
        };
        _this.calcStepOffsetWidth = debounce(_this.calcStepOffsetWidth, 150);
        return _this;
    }

    createClass(Steps, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.calcStepOffsetWidth();
            if (!isFlexSupported()) {
                this.setState({
                    flexSupported: false
                });
            }

            this.calculateUpperContentMaxHeight();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.calcStepOffsetWidth();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.calcTimeout) {
                clearTimeout(this.calcTimeout);
            }
            if (this.calcStepOffsetWidth && this.calcStepOffsetWidth.cancel) {
                this.calcStepOffsetWidth.cancel();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames,
                _this2 = this;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                _props$style = _props.style,
                style = _props$style === undefined ? {} : _props$style,
                className = _props.className,
                children = _props.children,
                direction = _props.direction,
                labelPlacement = _props.labelPlacement,
                iconPrefix = _props.iconPrefix,
                status = _props.status,
                size = _props.size,
                current = _props.current,
                progressDot = _props.progressDot,
                secondaryCurrent = _props.secondaryCurrent,
                restProps = objectWithoutProperties(_props, ['prefixCls', 'style', 'className', 'children', 'direction', 'labelPlacement', 'iconPrefix', 'status', 'size', 'current', 'progressDot', 'secondaryCurrent']);
            var _state = this.state,
                lastStepOffsetWidth = _state.lastStepOffsetWidth,
                flexSupported = _state.flexSupported;

            var filteredChildren = React.Children.toArray(children).filter(function (c) {
                return !!c;
            });
            var lastIndex = filteredChildren.length - 1;
            var adjustedlabelPlacement = !!progressDot ? 'vertical' : labelPlacement;
            var classString = classNames(prefixCls, prefixCls + '-' + direction, className, (_classNames = {}, defineProperty(_classNames, prefixCls + '-' + size, size), defineProperty(_classNames, prefixCls + '-label-' + adjustedlabelPlacement, direction === 'horizontal'), defineProperty(_classNames, prefixCls + '-dot', !!progressDot), _classNames));
            var lastStepNumber = 0;
            var lastSubStepNumber = 0;
            var marginStyle = direction === 'horizontal' && labelPlacement === 'vertical' ? { marginTop: this.state.upperContentHeight + 15 } : {};

            return React.createElement(
                'div',
                _extends({ className: classString, style: _extends({}, marginStyle, style) }, restProps, {
                    ref: function ref(element) {
                        return _this2.domNode = element;
                    } }),
                Children.map(filteredChildren, function (child, index) {
                    if (!child) {
                        return null;
                    }
                    if (!child.props.subStep) {
                        lastStepNumber++;
                        lastSubStepNumber = lastStepNumber;
                    } else {
                        lastSubStepNumber += 0.01;
                    }

                    var childProps = _extends({
                        stepNumber: child.props.subStep ? lastSubStepNumber : lastStepNumber,
                        prefixCls: prefixCls,
                        iconPrefix: iconPrefix,
                        wrapperStyle: style,
                        progressDot: progressDot,
                        upperContentHeight: _this2.state.upperContentHeight
                    }, child.props);
                    if (!flexSupported && direction !== 'vertical' && index !== lastIndex) {
                        childProps.itemWidth = 100 / lastIndex + '%';
                        childProps.adjustMarginRight = -Math.round(lastStepOffsetWidth / lastIndex + 1);
                    }
                    // fix tail color
                    if (status === 'error' && index === current - 1) {
                        childProps.className = prefixCls + '-next-error';
                    }

                    if (direction === 'horizontal' && labelPlacement === 'vertical') {
                        childProps.showUpperContent = true;
                    }

                    var stepNumber = child.props.subStep ? lastSubStepNumber - 1 : lastStepNumber - 1;

                    stepNumber = Number(stepNumber.toFixed(2));

                    if (!child.props.status) {
                        if (stepNumber === current) {
                            childProps.status = status;
                        } else if (stepNumber < current) {
                            childProps.status = 'finish';
                        } else {
                            childProps.status = 'wait';
                        }
                    }

                    if (stepNumber === secondaryCurrent && childProps.upperTitle && childProps.upperTitle.length) {
                        childProps.secondaryCurrent = true;
                    }

                    return cloneElement(child, childProps);
                })
            );
        }
    }]);
    return Steps;
}(Component);

Steps.propTypes = {
    prefixCls: PropTypes.string,
    className: PropTypes.string,
    iconPrefix: PropTypes.string,
    direction: PropTypes.string,
    labelPlacement: PropTypes.string,
    children: PropTypes.any,
    status: PropTypes.string,
    size: PropTypes.string,
    progressDot: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    style: PropTypes.object,
    current: PropTypes.number,
    secondaryCurrent: PropTypes.number
};
Steps.defaultProps = {
    prefixCls: 'rc-steps',
    iconPrefix: 'rc',
    direction: 'horizontal',
    labelPlacement: 'horizontal',
    current: 0,
    secondaryCurrent: undefined,
    status: 'process',
    size: '',
    progressDot: false
};

function isString(str) {
    return typeof str === 'string';
}

var Step = function (_React$Component) {
    inherits(Step, _React$Component);

    function Step() {
        classCallCheck(this, Step);
        return possibleConstructorReturn(this, (Step.__proto__ || Object.getPrototypeOf(Step)).apply(this, arguments));
    }

    createClass(Step, [{
        key: 'renderIconNode',
        value: function renderIconNode() {
            var _classNames;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                progressDot = _props.progressDot,
                stepNumber = _props.stepNumber,
                status = _props.status,
                title = _props.title,
                description = _props.description,
                icon = _props.icon,
                iconPrefix = _props.iconPrefix;

            var iconNode = void 0;
            var iconClassName = classNames(prefixCls + '-icon', iconPrefix + 'icon', (_classNames = {}, defineProperty(_classNames, iconPrefix + 'icon-' + icon, icon && isString(icon)), defineProperty(_classNames, iconPrefix + 'icon-check', !icon && status === 'finish'), defineProperty(_classNames, iconPrefix + 'icon-cross', !icon && status === 'error'), _classNames));
            var iconDot = React.createElement('span', { className: prefixCls + '-icon-dot' });
            // `progressDot` enjoy the highest priority
            if (progressDot) {
                if (typeof progressDot === 'function') {
                    iconNode = React.createElement(
                        'span',
                        { className: prefixCls + '-icon' },
                        progressDot(iconDot, { index: stepNumber - 1, status: status, title: title, description: description })
                    );
                } else {
                    iconNode = React.createElement(
                        'span',
                        { className: prefixCls + '-icon' },
                        iconDot
                    );
                }
            } else if (icon && !isString(icon)) {
                iconNode = React.createElement(
                    'span',
                    { className: prefixCls + '-icon' },
                    icon
                );
            } else if (icon || status === 'finish' || status === 'error') {
                iconNode = React.createElement('span', { className: iconClassName });
            } else {
                iconNode = React.createElement(
                    'span',
                    { className: prefixCls + '-icon' },
                    stepNumber
                );
            }
            return iconNode;
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames2;

            var _props2 = this.props,
                className = _props2.className,
                prefixCls = _props2.prefixCls,
                style = _props2.style,
                itemWidth = _props2.itemWidth,
                _props2$status = _props2.status,
                status = _props2$status === undefined ? 'wait' : _props2$status,
                iconPrefix = _props2.iconPrefix,
                icon = _props2.icon,
                wrapperStyle = _props2.wrapperStyle,
                adjustMarginRight = _props2.adjustMarginRight,
                stepNumber = _props2.stepNumber,
                description = _props2.description,
                title = _props2.title,
                upperTitle = _props2.upperTitle,
                progressDot = _props2.progressDot,
                tailContent = _props2.tailContent,
                subStep = _props2.subStep,
                secondaryCurrent = _props2.secondaryCurrent,
                showUpperContent = _props2.showUpperContent,
                upperContentHeight = _props2.upperContentHeight,
                restProps = objectWithoutProperties(_props2, ['className', 'prefixCls', 'style', 'itemWidth', 'status', 'iconPrefix', 'icon', 'wrapperStyle', 'adjustMarginRight', 'stepNumber', 'description', 'title', 'upperTitle', 'progressDot', 'tailContent', 'subStep', 'secondaryCurrent', 'showUpperContent', 'upperContentHeight']);


            var classString = classNames(prefixCls + '-item', prefixCls + '-item-' + status, className, (_classNames2 = {}, defineProperty(_classNames2, prefixCls + '-item-custom', icon), defineProperty(_classNames2, prefixCls + '-item-sub-step', subStep), defineProperty(_classNames2, prefixCls + '-item-secondary-current', secondaryCurrent), _classNames2));
            var stepItemStyle = _extends({}, style);
            if (itemWidth) {
                stepItemStyle.width = itemWidth;
            }
            if (adjustMarginRight) {
                stepItemStyle.marginRight = adjustMarginRight;
            }

            var upperTopStyle = upperContentHeight > 0 ? { top: -(upperContentHeight + 22) } : {};

            return React.createElement(
                'div',
                _extends({}, restProps, {
                    className: classString,
                    style: stepItemStyle
                }),
                React.createElement(
                    'div',
                    { className: prefixCls + '-item-tail' },
                    tailContent
                ),
                React.createElement(
                    'div',
                    { className: prefixCls + '-item-icon' },
                    this.renderIconNode()
                ),
                React.createElement(
                    'div',
                    { className: prefixCls + '-item-content' },
                    React.createElement(
                        'div',
                        { className: prefixCls + '-item-title' },
                        title
                    ),
                    description && React.createElement(
                        'div',
                        { className: prefixCls + '-item-description' },
                        description
                    )
                ),
                showUpperContent && React.createElement(
                    'div',
                    { className: prefixCls + '-item-upper-content', style: upperTopStyle },
                    upperTitle && React.createElement(
                        'div',
                        { className: prefixCls + '-item-upper-title' },
                        upperTitle
                    )
                )
            );
        }
    }]);
    return Step;
}(React.Component);

Step.propTypes = {
    className: PropTypes.string,
    prefixCls: PropTypes.string,
    style: PropTypes.object,
    wrapperStyle: PropTypes.object,
    itemWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    status: PropTypes.string,
    iconPrefix: PropTypes.string,
    icon: PropTypes.node,
    adjustMarginRight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    stepNumber: PropTypes.number,
    description: PropTypes.any,
    upperTitle: PropTypes.any,
    title: PropTypes.any,
    progressDot: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    tailContent: PropTypes.any,
    subStep: PropTypes.bool,
    secondaryCurrent: PropTypes.bool
};

Steps.Step = Step;

export { Step };
export default Steps;
